class AccordionHubspotForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.emailCheck()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.emailCheck = this.emailCheck.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    this.listeners.add(this.els.email.element, 'input', this.emailCheck)
    this.listeners.add(this.els.email.element, 'change', this.emailCheck)
  }

  emailCheck () {
    const emailValue = this.els.email.element.value
    if (emailValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      this.els.submit.element.disabled = false
    } else {
      this.els.submit.element.disabled = true
    }
  }

  handleSubmit (event) {
    event.preventDefault()

    const customerEmail = this.els.email?.element?.value

    if (!customerEmail) return

    this.els.form.element.setAttribute('aria-hidden', true)
    this.els.submitted.element.setAttribute('aria-hidden', false)

    window.BAO.dispatchEvent(window.BAO.EVENTS.HUBSPOT.FORM_SUBMITTED, {
      customerEmail,
    })

    setTimeout(() => {
      window.location.href = this.els.submittedLink.element.href
    }, this.dataset.delay || 5000)
  }
}

if (!customElements.get('accordion-hubspot-form')) {
  customElements.define('accordion-hubspot-form', AccordionHubspotForm)
}
